/**
 * @param props.className - Positioning for the mark
 * @returns A printer's registration target
 */
function RegistrationMark({ className }: { className: string }) {
  return (
    <svg aria-hidden viewBox="0 0 40 40" className={`absolute size-7 ${className}`}>
      <circle cx="20" cy="20" r="9" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M20 4v32M4 20h32" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

/**
 * Crop marks in the four corners and registration targets on the vertical centre line, the trim
 * furniture of the print treatment. The parent needs `relative`.
 *
 * @param props.className - Ink colour (as `text-*`) and stacking; defaults to the maroon key on paper
 * @returns The marks layer
 */
export function PrintMarks({ className = 'z-[9] text-maroon-900/45' }: { className?: string }) {
  const corner = 'absolute size-5 border-current';

  return (
    <div aria-hidden className={`pointer-events-none absolute inset-3 md:inset-6 ${className}`}>
      <span className={`${corner} top-0 left-0 border-t-[1.5px] border-l-[1.5px]`} />
      <span className={`${corner} top-0 right-0 border-t-[1.5px] border-r-[1.5px]`} />
      <span className={`${corner} bottom-0 left-0 border-b-[1.5px] border-l-[1.5px]`} />
      <span className={`${corner} right-0 bottom-0 border-r-[1.5px] border-b-[1.5px]`} />
      <RegistrationMark className="top-0 left-1/2 hidden -translate-x-1/2 md:block" />
      <RegistrationMark className="bottom-0 left-1/2 hidden -translate-x-1/2 md:block" />
    </div>
  );
}
